var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCircleChevronLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 0.666748C12.05 0.666748 15.3333 3.95008 15.3333 8.00008C15.3333 12.0501 12.05 15.3334 8.00001 15.3334C3.95001 15.3334 0.666677 12.0501 0.666677 8.00008C0.666677 3.95008 3.95001 0.666748 8.00001 0.666748ZM9.47134 5.80475C9.59278 5.67901 9.65998 5.51061 9.65846 5.33581C9.65694 5.16102 9.58683 4.99381 9.46322 4.8702C9.33962 4.7466 9.17241 4.67648 8.99761 4.67496C8.82281 4.67345 8.65441 4.74064 8.52868 4.86208L5.86201 7.52875C5.73703 7.65377 5.66682 7.8233 5.66682 8.00008C5.66682 8.17686 5.73703 8.3464 5.86201 8.47141L8.52868 11.1381C8.65441 11.2595 8.82281 11.3267 8.99761 11.3252C9.17241 11.3237 9.33962 11.2536 9.46322 11.13C9.58683 11.0064 9.65694 10.8391 9.65846 10.6643C9.65998 10.4896 9.59278 10.3211 9.47134 10.1954L7.27601 8.00008L9.47134 5.80475Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCircleChevronLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_circle-chevron-left.b31dda2a.svg";
export { ForwardRef as ReactComponent };